export function Resources() {
    return <h1>Resources</h1>;
  }